import type { ProfileTranslations } from "../interfaces/profile";

export const profileTranslations: ProfileTranslations = {
  eyebrow: "Conta",
  page_title: "Meu Perfil",
  page_sub: "Suas informações de conta e dados de contato.",
  identity_title: "Seu perfil",
  identity_sub: "Essas informações aparecem nos comprovantes e no histórico visível para sua equipe.",
  contact_section_title: "Informações de Contato",
  account_section_title: "Detalhes da Conta",
  email_label: "Email",
  phone_label: "Telefone",
  country_label: "País",
  language_label: "Idioma",
  status_label: "Status",
  two_factor_label: "Autenticação de dois fatores",
  last_login_label: "Último acesso",
  two_factor_enabled: "Ativada",
  two_factor_disabled: "Desativada",
  not_specified: "Não especificado",
};
